// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as CalculatorsIndexRouteImport } from './routes/calculators/index'
import { Route as CalculatorsSlugRouteImport } from './routes/calculators/$slug'
import { Route as DeIndexRouteImport } from './routes/de/index'
import { Route as DeSlugRouteImport } from './routes/de/$slug'
import { Route as DeAboutRouteImport } from './routes/de/about'
import { Route as DeContactRouteImport } from './routes/de/contact'
import { Route as DeDisclaimerRouteImport } from './routes/de/disclaimer'
import { Route as DePrivacyPolicyRouteImport } from './routes/de/privacy-policy'
import { Route as DeTermsOfUseRouteImport } from './routes/de/terms-of-use'
import { Route as EsIndexRouteImport } from './routes/es/index'
import { Route as EsSlugRouteImport } from './routes/es/$slug'
import { Route as EsAboutRouteImport } from './routes/es/about'
import { Route as EsContactRouteImport } from './routes/es/contact'
import { Route as EsDisclaimerRouteImport } from './routes/es/disclaimer'
import { Route as EsPrivacyPolicyRouteImport } from './routes/es/privacy-policy'
import { Route as EsTermsOfUseRouteImport } from './routes/es/terms-of-use'
import { Route as FrIndexRouteImport } from './routes/fr/index'
import { Route as FrSlugRouteImport } from './routes/fr/$slug'
import { Route as FrAboutRouteImport } from './routes/fr/about'
import { Route as FrContactRouteImport } from './routes/fr/contact'
import { Route as FrDisclaimerRouteImport } from './routes/fr/disclaimer'
import { Route as FrPrivacyPolicyRouteImport } from './routes/fr/privacy-policy'
import { Route as FrTermsOfUseRouteImport } from './routes/fr/terms-of-use'
import { Route as FreeToolsIndexRouteImport } from './routes/free-tools/index'
import { Route as FreeToolsSlugRouteImport } from './routes/free-tools/$slug'
import { Route as PdfToolsIndexRouteImport } from './routes/pdf-tools/index'
import { Route as PdfToolsSlugRouteImport } from './routes/pdf-tools/$slug'
import { Route as PtBrIndexRouteImport } from './routes/pt-br/index'
import { Route as PtBrSlugRouteImport } from './routes/pt-br/$slug'
import { Route as PtBrAboutRouteImport } from './routes/pt-br/about'
import { Route as PtBrContactRouteImport } from './routes/pt-br/contact'
import { Route as PtBrDisclaimerRouteImport } from './routes/pt-br/disclaimer'
import { Route as PtBrPrivacyPolicyRouteImport } from './routes/pt-br/privacy-policy'
import { Route as PtBrTermsOfUseRouteImport } from './routes/pt-br/terms-of-use'
import { Route as DeCalculatorsIndexRouteImport } from './routes/de/calculators/index'
import { Route as DeCalculatorsSlugRouteImport } from './routes/de/calculators/$slug'
import { Route as DePdfToolsIndexRouteImport } from './routes/de/pdf-tools/index'
import { Route as DePdfToolsSlugRouteImport } from './routes/de/pdf-tools/$slug'
import { Route as EsCalculatorsIndexRouteImport } from './routes/es/calculators/index'
import { Route as EsCalculatorsSlugRouteImport } from './routes/es/calculators/$slug'
import { Route as EsPdfToolsIndexRouteImport } from './routes/es/pdf-tools/index'
import { Route as EsPdfToolsSlugRouteImport } from './routes/es/pdf-tools/$slug'
import { Route as FrCalculatorsIndexRouteImport } from './routes/fr/calculators/index'
import { Route as FrCalculatorsSlugRouteImport } from './routes/fr/calculators/$slug'
import { Route as FrPdfToolsIndexRouteImport } from './routes/fr/pdf-tools/index'
import { Route as FrPdfToolsSlugRouteImport } from './routes/fr/pdf-tools/$slug'
import { Route as PtBrCalculatorsIndexRouteImport } from './routes/pt-br/calculators/index'
import { Route as PtBrCalculatorsSlugRouteImport } from './routes/pt-br/calculators/$slug'
import { Route as PtBrPdfToolsIndexRouteImport } from './routes/pt-br/pdf-tools/index'
import { Route as PtBrPdfToolsSlugRouteImport } from './routes/pt-br/pdf-tools/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const TermsOfUseRoute = TermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => rootRouteImport
          })
const CalculatorsIndexRoute = CalculatorsIndexRouteImport.update({
            id: '/calculators/',path: '/calculators/',getParentRoute: () => rootRouteImport
          })
const CalculatorsSlugRoute = CalculatorsSlugRouteImport.update({
            id: '/calculators/$slug',path: '/calculators/$slug',getParentRoute: () => rootRouteImport
          })
const DeIndexRoute = DeIndexRouteImport.update({
            id: '/de/',path: '/de/',getParentRoute: () => rootRouteImport
          })
const DeSlugRoute = DeSlugRouteImport.update({
            id: '/de/$slug',path: '/de/$slug',getParentRoute: () => rootRouteImport
          })
const DeAboutRoute = DeAboutRouteImport.update({
            id: '/de/about',path: '/de/about',getParentRoute: () => rootRouteImport
          })
const DeContactRoute = DeContactRouteImport.update({
            id: '/de/contact',path: '/de/contact',getParentRoute: () => rootRouteImport
          })
const DeDisclaimerRoute = DeDisclaimerRouteImport.update({
            id: '/de/disclaimer',path: '/de/disclaimer',getParentRoute: () => rootRouteImport
          })
const DePrivacyPolicyRoute = DePrivacyPolicyRouteImport.update({
            id: '/de/privacy-policy',path: '/de/privacy-policy',getParentRoute: () => rootRouteImport
          })
const DeTermsOfUseRoute = DeTermsOfUseRouteImport.update({
            id: '/de/terms-of-use',path: '/de/terms-of-use',getParentRoute: () => rootRouteImport
          })
const EsIndexRoute = EsIndexRouteImport.update({
            id: '/es/',path: '/es/',getParentRoute: () => rootRouteImport
          })
const EsSlugRoute = EsSlugRouteImport.update({
            id: '/es/$slug',path: '/es/$slug',getParentRoute: () => rootRouteImport
          })
const EsAboutRoute = EsAboutRouteImport.update({
            id: '/es/about',path: '/es/about',getParentRoute: () => rootRouteImport
          })
const EsContactRoute = EsContactRouteImport.update({
            id: '/es/contact',path: '/es/contact',getParentRoute: () => rootRouteImport
          })
const EsDisclaimerRoute = EsDisclaimerRouteImport.update({
            id: '/es/disclaimer',path: '/es/disclaimer',getParentRoute: () => rootRouteImport
          })
const EsPrivacyPolicyRoute = EsPrivacyPolicyRouteImport.update({
            id: '/es/privacy-policy',path: '/es/privacy-policy',getParentRoute: () => rootRouteImport
          })
const EsTermsOfUseRoute = EsTermsOfUseRouteImport.update({
            id: '/es/terms-of-use',path: '/es/terms-of-use',getParentRoute: () => rootRouteImport
          })
const FrIndexRoute = FrIndexRouteImport.update({
            id: '/fr/',path: '/fr/',getParentRoute: () => rootRouteImport
          })
const FrSlugRoute = FrSlugRouteImport.update({
            id: '/fr/$slug',path: '/fr/$slug',getParentRoute: () => rootRouteImport
          })
const FrAboutRoute = FrAboutRouteImport.update({
            id: '/fr/about',path: '/fr/about',getParentRoute: () => rootRouteImport
          })
const FrContactRoute = FrContactRouteImport.update({
            id: '/fr/contact',path: '/fr/contact',getParentRoute: () => rootRouteImport
          })
const FrDisclaimerRoute = FrDisclaimerRouteImport.update({
            id: '/fr/disclaimer',path: '/fr/disclaimer',getParentRoute: () => rootRouteImport
          })
const FrPrivacyPolicyRoute = FrPrivacyPolicyRouteImport.update({
            id: '/fr/privacy-policy',path: '/fr/privacy-policy',getParentRoute: () => rootRouteImport
          })
const FrTermsOfUseRoute = FrTermsOfUseRouteImport.update({
            id: '/fr/terms-of-use',path: '/fr/terms-of-use',getParentRoute: () => rootRouteImport
          })
const FreeToolsIndexRoute = FreeToolsIndexRouteImport.update({
            id: '/free-tools/',path: '/free-tools/',getParentRoute: () => rootRouteImport
          })
const FreeToolsSlugRoute = FreeToolsSlugRouteImport.update({
            id: '/free-tools/$slug',path: '/free-tools/$slug',getParentRoute: () => rootRouteImport
          })
const PdfToolsIndexRoute = PdfToolsIndexRouteImport.update({
            id: '/pdf-tools/',path: '/pdf-tools/',getParentRoute: () => rootRouteImport
          })
const PdfToolsSlugRoute = PdfToolsSlugRouteImport.update({
            id: '/pdf-tools/$slug',path: '/pdf-tools/$slug',getParentRoute: () => rootRouteImport
          })
const PtBrIndexRoute = PtBrIndexRouteImport.update({
            id: '/pt-br/',path: '/pt-br/',getParentRoute: () => rootRouteImport
          })
const PtBrSlugRoute = PtBrSlugRouteImport.update({
            id: '/pt-br/$slug',path: '/pt-br/$slug',getParentRoute: () => rootRouteImport
          })
const PtBrAboutRoute = PtBrAboutRouteImport.update({
            id: '/pt-br/about',path: '/pt-br/about',getParentRoute: () => rootRouteImport
          })
const PtBrContactRoute = PtBrContactRouteImport.update({
            id: '/pt-br/contact',path: '/pt-br/contact',getParentRoute: () => rootRouteImport
          })
const PtBrDisclaimerRoute = PtBrDisclaimerRouteImport.update({
            id: '/pt-br/disclaimer',path: '/pt-br/disclaimer',getParentRoute: () => rootRouteImport
          })
const PtBrPrivacyPolicyRoute = PtBrPrivacyPolicyRouteImport.update({
            id: '/pt-br/privacy-policy',path: '/pt-br/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PtBrTermsOfUseRoute = PtBrTermsOfUseRouteImport.update({
            id: '/pt-br/terms-of-use',path: '/pt-br/terms-of-use',getParentRoute: () => rootRouteImport
          })
const DeCalculatorsIndexRoute = DeCalculatorsIndexRouteImport.update({
            id: '/de/calculators/',path: '/de/calculators/',getParentRoute: () => rootRouteImport
          })
const DeCalculatorsSlugRoute = DeCalculatorsSlugRouteImport.update({
            id: '/de/calculators/$slug',path: '/de/calculators/$slug',getParentRoute: () => rootRouteImport
          })
const DePdfToolsIndexRoute = DePdfToolsIndexRouteImport.update({
            id: '/de/pdf-tools/',path: '/de/pdf-tools/',getParentRoute: () => rootRouteImport
          })
const DePdfToolsSlugRoute = DePdfToolsSlugRouteImport.update({
            id: '/de/pdf-tools/$slug',path: '/de/pdf-tools/$slug',getParentRoute: () => rootRouteImport
          })
const EsCalculatorsIndexRoute = EsCalculatorsIndexRouteImport.update({
            id: '/es/calculators/',path: '/es/calculators/',getParentRoute: () => rootRouteImport
          })
const EsCalculatorsSlugRoute = EsCalculatorsSlugRouteImport.update({
            id: '/es/calculators/$slug',path: '/es/calculators/$slug',getParentRoute: () => rootRouteImport
          })
const EsPdfToolsIndexRoute = EsPdfToolsIndexRouteImport.update({
            id: '/es/pdf-tools/',path: '/es/pdf-tools/',getParentRoute: () => rootRouteImport
          })
const EsPdfToolsSlugRoute = EsPdfToolsSlugRouteImport.update({
            id: '/es/pdf-tools/$slug',path: '/es/pdf-tools/$slug',getParentRoute: () => rootRouteImport
          })
const FrCalculatorsIndexRoute = FrCalculatorsIndexRouteImport.update({
            id: '/fr/calculators/',path: '/fr/calculators/',getParentRoute: () => rootRouteImport
          })
const FrCalculatorsSlugRoute = FrCalculatorsSlugRouteImport.update({
            id: '/fr/calculators/$slug',path: '/fr/calculators/$slug',getParentRoute: () => rootRouteImport
          })
const FrPdfToolsIndexRoute = FrPdfToolsIndexRouteImport.update({
            id: '/fr/pdf-tools/',path: '/fr/pdf-tools/',getParentRoute: () => rootRouteImport
          })
const FrPdfToolsSlugRoute = FrPdfToolsSlugRouteImport.update({
            id: '/fr/pdf-tools/$slug',path: '/fr/pdf-tools/$slug',getParentRoute: () => rootRouteImport
          })
const PtBrCalculatorsIndexRoute = PtBrCalculatorsIndexRouteImport.update({
            id: '/pt-br/calculators/',path: '/pt-br/calculators/',getParentRoute: () => rootRouteImport
          })
const PtBrCalculatorsSlugRoute = PtBrCalculatorsSlugRouteImport.update({
            id: '/pt-br/calculators/$slug',path: '/pt-br/calculators/$slug',getParentRoute: () => rootRouteImport
          })
const PtBrPdfToolsIndexRoute = PtBrPdfToolsIndexRouteImport.update({
            id: '/pt-br/pdf-tools/',path: '/pt-br/pdf-tools/',getParentRoute: () => rootRouteImport
          })
const PtBrPdfToolsSlugRoute = PtBrPdfToolsSlugRouteImport.update({
            id: '/pt-br/pdf-tools/$slug',path: '/pt-br/pdf-tools/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,DisclaimerRoute: DisclaimerRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsOfUseRoute: TermsOfUseRoute,CalculatorsSlugRoute: CalculatorsSlugRoute,DeSlugRoute: DeSlugRoute,DeAboutRoute: DeAboutRoute,DeContactRoute: DeContactRoute,DeDisclaimerRoute: DeDisclaimerRoute,DePrivacyPolicyRoute: DePrivacyPolicyRoute,DeTermsOfUseRoute: DeTermsOfUseRoute,EsSlugRoute: EsSlugRoute,EsAboutRoute: EsAboutRoute,EsContactRoute: EsContactRoute,EsDisclaimerRoute: EsDisclaimerRoute,EsPrivacyPolicyRoute: EsPrivacyPolicyRoute,EsTermsOfUseRoute: EsTermsOfUseRoute,FrSlugRoute: FrSlugRoute,FrAboutRoute: FrAboutRoute,FrContactRoute: FrContactRoute,FrDisclaimerRoute: FrDisclaimerRoute,FrPrivacyPolicyRoute: FrPrivacyPolicyRoute,FrTermsOfUseRoute: FrTermsOfUseRoute,FreeToolsSlugRoute: FreeToolsSlugRoute,PdfToolsSlugRoute: PdfToolsSlugRoute,PtBrSlugRoute: PtBrSlugRoute,PtBrAboutRoute: PtBrAboutRoute,PtBrContactRoute: PtBrContactRoute,PtBrDisclaimerRoute: PtBrDisclaimerRoute,PtBrPrivacyPolicyRoute: PtBrPrivacyPolicyRoute,PtBrTermsOfUseRoute: PtBrTermsOfUseRoute,CalculatorsIndexRoute: CalculatorsIndexRoute,DeIndexRoute: DeIndexRoute,EsIndexRoute: EsIndexRoute,FrIndexRoute: FrIndexRoute,FreeToolsIndexRoute: FreeToolsIndexRoute,PdfToolsIndexRoute: PdfToolsIndexRoute,PtBrIndexRoute: PtBrIndexRoute,DeCalculatorsSlugRoute: DeCalculatorsSlugRoute,DePdfToolsSlugRoute: DePdfToolsSlugRoute,EsCalculatorsSlugRoute: EsCalculatorsSlugRoute,EsPdfToolsSlugRoute: EsPdfToolsSlugRoute,FrCalculatorsSlugRoute: FrCalculatorsSlugRoute,FrPdfToolsSlugRoute: FrPdfToolsSlugRoute,PtBrCalculatorsSlugRoute: PtBrCalculatorsSlugRoute,PtBrPdfToolsSlugRoute: PtBrPdfToolsSlugRoute,DeCalculatorsIndexRoute: DeCalculatorsIndexRoute,DePdfToolsIndexRoute: DePdfToolsIndexRoute,EsCalculatorsIndexRoute: EsCalculatorsIndexRoute,EsPdfToolsIndexRoute: EsPdfToolsIndexRoute,FrCalculatorsIndexRoute: FrCalculatorsIndexRoute,FrPdfToolsIndexRoute: FrPdfToolsIndexRoute,PtBrCalculatorsIndexRoute: PtBrCalculatorsIndexRoute,PtBrPdfToolsIndexRoute: PtBrPdfToolsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)